/*
  Documentation page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import masteringBitcoinCash from '../assets/images/mastering-bitcoin-cash.jpg'
import slp from '../assets/images/slp-transparent.png'

function Documentation () {
  return (
    <>
      <Helmet>
        <title>Documentation - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row className='mb-5'>
          <Col md={6}>
            <h2>The Best Technical Reference:</h2>
            <p>
              Adapted from Mastering Bitcoin
              by <a href='https://twitter.com/aantonop' target='_blank' rel='noreferrer'>Andreas Antonopoulos</a>,
              {' '}<a href='http://zh.thedev.id/mastering-bitcoin-cash/' target='_blank' rel='noreferrer'>Mastering Bitcoin Cash</a> is
              the most approachable technical reference
              to working with the Bitcoin Cash protocol.
            </p>
            <div className='text-center'>
              <Button
                href='http://zh.thedev.id/mastering-bitcoin-cash/'
                target='_blank'
                rel='noreferrer'
                variant='primary'
              >
                More
              </Button>
            </div>
          </Col>
          <Col md={6}>
            <a href='http://zh.thedev.id/mastering-bitcoin-cash/' target='_blank' rel='noreferrer'>
              <img src={masteringBitcoinCash} alt='Mastering Bitcoin Cash' className='img-fluid' />
            </a>
          </Col>
        </Row>

        <Row className='g-4 mb-5'>
          <Col md={6}>
            <Card className='h-100 text-center'>
              <Card.Body>
                <i className='fas fa-cog fa-3x text-primary mb-3' />
                <Card.Title>The 'Cash Stack'</Card.Title>
                <Card.Text>
                  Learn about the 'full stack' of software required for a modern
                  phone app or website to communicate directly with the blockchain.
                </Card.Text>
                <Button
                  href='https://cashstack.info'
                  target='_blank'
                  rel='noreferrer'
                  variant='outline-primary'
                >
                  More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className='h-100 text-center'>
              <Card.Body>
                <i className='fas fa-code fa-3x text-primary mb-3' />
                <Card.Title>bch-js</Card.Title>
                <Card.Text>
                  This <a href='https://www.npmjs.com/package/@chris.troutner/bch-js' target='_blank' rel='noreferrer'>npm JavaScript library </a> can
                  be added to your node.js project
                  to instantly allow your app to talk to Bitcoin Cash Blockchain.
                </Card.Text>
                <Button
                  href='https://bchjs.fullstack.cash/'
                  target='_blank'
                  rel='noreferrer'
                  variant='outline-primary'
                >
                  More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className='h-100 text-center'>
              <Card.Body>
                <i className='fas fa-bolt fa-3x text-primary mb-3' />
                <Card.Title>bch-api</Card.Title>
                <Card.Text>
                  This REST API provides a simple HTTP interface for interacting
                  with the Bitcoin Cash blockchain. It's the back-end that powers
                  bch-js and other libraries.
                </Card.Text>
                <Button
                  href='https://api.fullstack.cash'
                  target='_blank'
                  rel='noreferrer'
                  variant='outline-primary'
                >
                  More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className='h-100 text-center'>
              <Card.Body>
                <img src={slp} alt='SLP' className='img-fluid mb-3' style={{ maxHeight: '60px' }} />
                <Card.Title>SLP (Simple Ledger Protocol)</Card.Title>
                <Card.Text>
                  SLP tokens are a way to create and manage tokens on the Bitcoin Cash blockchain.
                  Learn how to create, send, and manage SLP tokens.
                </Card.Text>
                <Button
                  href='https://slp.dev'
                  target='_blank'
                  rel='noreferrer'
                  variant='outline-primary'
                >
                  More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Documentation
